export const clubsLinkingScreens = {
  Clubs: 'clubs',
  CreateClub: 'clubs/create',
  ClubCreated: 'clubs/created/:clubId',
  ClubProfile: 'clubs/profile/:clubId',
  ClubRoom: 'clubs/room/:clubId',
  ClubAdmin: 'clubs/admin/:clubId',
  InviteRedeem: 'clubs/invite/:code',
  ClubStandings: 'clubs/standings/:clubId?',
} as const;
